import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import {
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  Subject,
  debounceTime,
  distinctUntilChanged,
  filter,
  takeUntil,
} from 'rxjs';
import { ClientsService } from 'src/app/services/clients/clients.service';
import { PayeeFormFieldComponent } from '../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { PayeeInputDirective } from '../../../../shared/payee-input/payee-input.directive';
import { MatError } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-notification-settings',
  templateUrl: './notification-settings.component.html',
  styleUrls: ['./notification-settings.component.scss'],
  imports: [
    PayeeFormFieldComponent,
    MatProgressSpinner,
    PayeeInputDirective,
    FormsModule,
    ReactiveFormsModule,
    MatError,
    TranslateModule,
  ],
})
export class NotificationSettingsComponent implements OnInit, OnDestroy {
  private clientsService = inject(ClientsService);

  private readonly destroy = new Subject<void>();
  readonly financeEmailControl = new FormControl<string | null>(null, [
    Validators.email,
  ]);
  readonly loading = signal(false);

  ngOnInit(): void {
    this.clientsService.selectedClientSubject
      .pipe(takeUntil(this.destroy))
      .subscribe((c) => {
        this.financeEmailControl.patchValue(c?.finance_email ?? null, {
          emitEvent: false,
        });
      });

    this.financeEmailControl.valueChanges
      .pipe(
        takeUntil(this.destroy),
        debounceTime(1000),
        distinctUntilChanged(),
        filter(() => this.financeEmailControl.valid && !this.loading()),
      )
      .subscribe(async (financeEmail) => {
        try {
          this.loading.set(true);

          await this.clientsService.updateNotificationSettings({
            finance_email: financeEmail,
          });
        } catch (error) {
          console.error('Error while saving finance email', error);
        } finally {
          this.loading.set(false);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
